export default {"src":"/_next/static/media/company_logo.dde2a636.svg","height":243,"width":953,"blurWidth":0,"blurHeight":0};